import {Endpoint} from '../endpoint';
import {EstimateGroupId, GroupNoteId, TimeMaterialGroupNotesResponse} from "@business/entities/tm";

export function fetchGroupNotes(groupId: EstimateGroupId) {
    return Endpoint.get<TimeMaterialGroupNotesResponse[]>(`@gc/tm-group-notes/${groupId}`,);
}

export function createGroupNote(groupId: EstimateGroupId, note: string) {
    return Endpoint.post<TimeMaterialGroupNotesResponse>(`@gc/tm-group-notes/${groupId}`, {data: {note}});
}

export function updateGroupNote(noteId: GroupNoteId, note: string) {
    return Endpoint.patch<TimeMaterialGroupNotesResponse>(`@gc/tm-group-notes/${noteId}`, {data: {note}});
}

export function deleteGroupNote(noteId: GroupNoteId) {
    return Endpoint.delete<void>(`@gc/tm-group-notes/${noteId}`);
}
